// src/store/index.js
// src/store/index.js
// import { defineStore } from "pinia";

// export const useFavoriteStore = defineStore("favorite", {
//   state: () => ({
//     favoriteSchools: [],//存储收藏的院校

//   }),
//   actions: {
//     toggleFavorite(school) {
//       const index = this.favoriteSchools.findIndex((s) => s.id === school.id);
//       if (index > -1) {
//         this.favoriteSchools.splice(index, 1); // 取消收藏
//       } else {
//         this.favoriteSchools.push({ ...school }); // 添加收藏
//       }
//     },
//   },
//   persist: true,
// });
import { defineStore } from "pinia";
import axios from "@/api/axiosConfig";

export const useFavoriteStore = defineStore("favorite", {
  state: () => ({
    favoriteSchools: [], // 存储收藏的学校
    loading: false,
    error: null,
  }),
  actions: {
    // 获取用户收藏列表
    async fetchFavorites(token) {
      this.loading = true;
      this.error = null;
      try {
        const res = await axios.post(
          "/interface/schoolcollect/schoolcollectlist",
          {
            token,
          }
        );
        if (res.data.code === 200) {
          this.favoriteSchools = res.data.data || [];
        } else {
          throw new Error(res.data.msg || "获取收藏失败");
        }
      } catch (err) {
        this.error = err.message;
        console.error("获取收藏失败:", err);
      } finally {
        this.loading = false;
      }
    },

    // 添加收藏
    async addFavorite(token, schoolId) {
      this.loading = true;
      this.error = null;

      try {
        const res = await axios.post(
          "/interface/schoolcollect/chooseschoolcollect",
          {
            token,
            schoolId,
          }
        );
        // console.log("-----------");
        // console.log("addFavorite response:", res.data); // 打印响应数据
        if (res.data.code === 200) {
          // this.favoriteSchools = res.data.data || [];
          // 假设接口返回的是新增的学校对象
          const newSchool = res.data.data;
          this.favoriteSchools.push(newSchool); // 局部添加
          return newSchool; // 返回给调用方使用
        } else {
          throw new Error(res.data.msg || "添加收藏失败");
        }
      } catch (err) {
        this.error = err.message;
        console.error("添加收藏失败:", err);
      } finally {
        this.loading = false;
      }
    },

    // 取消收藏
    async removeFavorite(token, schoolId) {
      this.loading = true;
      this.error = null;
      try {
        const res = await axios.post(
          "/interface/schoolcollect/cancelschoolcollectlist",
          {
            token,
            schoolId,
          }
        );
        if (res.data.code === 200) {
          // this.favoriteSchools = res.data.data || [];
          // this.favoriteSchools = this.favoriteSchools.filter(
          //   (s) => s.id !== schoolId
          // );
          // 从本地收藏列表中移除该学校
          this.favoriteSchools = this.favoriteSchools.filter(
            (s) => s && s.id !== schoolId
          );
        } else {
          throw new Error(res.data.msg || "取消收藏失败");
        }
      } catch (err) {
        this.error = err.message;
        console.error("取消收藏失败:", err);
      } finally {
        this.loading = false;
      }
    },
  },
  persist: true, // 如果你用了 pinia-plugin-persistedstate 插件
});
